/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-circle[_ngcontent-%COMP%]{width:20px;height:18px;line-height:18px;text-align:center;padding:0;font-size:.9rem}.btn-report[_ngcontent-%COMP%]{width:40px;height:18px;line-height:18px;text-align:center;padding:0;font-size:.9rem}"];
export { styles as styles };
